import { AuthenticationContext, adalFetch, withAdalLogin, AdalConfig, adalGetToken } from 'react-adal'

// In development mode, window.env hasn't been defined at this point,
// but process.env should contain the vars from .env.
export const adalConfig: AdalConfig = process.env.NODE_ENV === 'development' && process.env.REACT_APP_SSO_TEST_MODE === 'true'
  ? {
    tenant: process.env.REACT_APP_AZURE_TENANT_ID,
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    redirectUri: 'http://localhost:3000/',
    endpoints: {
      api: process.env.REACT_APP_AZURE_CLIENT_ID || ''
    },
    cacheLocation: 'sessionStorage',
  }
  : {
    tenant: window.env.REACT_APP_AZURE_TENANT_ID,
    clientId: window.env.REACT_APP_AZURE_CLIENT_ID,
    redirectUri: window.location.origin,
    endpoints: {
      api: window.env.REACT_APP_AZURE_CLIENT_ID,
    },
    cacheLocation: 'sessionStorage',
  }

export const authContext = new AuthenticationContext(adalConfig)

export const adalApiFetch = (fetch: any, url: any, options: any) =>
  adalFetch(authContext, adalConfig.endpoints!.api, fetch, url, options)

export const getToken = async (): Promise<string | null> => {
  return adalGetToken(authContext, adalConfig.endpoints!.api)
}

export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints!.api)
